{
  "manager": {
    "create": {
      "nameLabel": "Name",
      "namePlaceholder": "Enter a name for the tag",
      "displayForRegistration": "Display this tag in the registration flow.",
      "editTitle": "Edit Tag",
      "createTitle": "Create Tag",
      "entity": "Tag"
    },
    "index": {
      "title": "Tags"
    },
    "genericTagInput": {
      "searchOrAddTag": "Search or add a tag"
    },
    "tagFilter": {
      "filterByTags": "Filter by Tags",
      "selectOneOrMore": "Select one or more"
    },
    "modalAssignTags": {
      "pressLabel": "Press",
      "enterKey": "Enter",
      "toCreate": "to create",
      "noTagsYet": "No tags yet. Start typing to create one.",
      "pickTagsLead": "Pick one or more tags, or type a new name and press",
      "toCreateIt": "to create it."
    }
  }
}
